// extracted by css-extract-rspack-plugin
export default {"button_override":"g7Wxw","buttonOverride":"g7Wxw","#":"eMjbk","icon":"TBXrZ","number":"ASyrx","label":"nRHAt"};